if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
        this.isSyncingQuantity = false;
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get mainProductInfo() {
        return document.querySelector(`product-info[data-product-id="${this.productId}"]`);
      }
      get productFormActions() {
        return document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);
      }
      get select() {
        return this.querySelector('select');
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.container = this.closest('.sticky-atc-bar');
        this.submitButton = this.querySelector('[type="submit"]');
        this.selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;

        this.variantData = this.getVariantData();

        this.init();
        this.boundSelectHandler = (e) => {
          if (this.isUpdating) return;

          const selectEl = this.querySelector(this.selectors.variantIdSelect);
          const selectedOption = selectEl?.options[selectEl.selectedIndex];
          if (selectedOption?.dataset.siblingVariantId && selectedOption?.dataset.siblingProductUrl) {
            const productInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
            if (productInfo && typeof productInfo.switchSibling === 'function') {
              productInfo.switchSibling(selectedOption.dataset.siblingProductUrl, selectedOption.dataset.siblingVariantId);
            }
            return;
          }

          this.isUpdating = true;

          this.updateQuantityInput();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formSticky: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }

          /* Update product image when variant changes in sticky ATC */
          if (this.currentVariant) {
            this.updateProductImage(this.currentVariant);
          }
        };
        this.select.addEventListener('change', this.boundSelectHandler);

        const hasRequiredFields = this.validateMainProductRequiredFields();
        if (hasRequiredFields) {
          this.boundSubmitHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.productFormActions.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
              this.productFormActions.requestSubmit();
            }, 300);
          };
          this.submitButton.addEventListener('click', this.boundSubmitHandler);
        }
      }

      validateMainProductRequiredFields() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return true;
        const requiredFields = mainForm.querySelectorAll('[data-custom-property]');
        return requiredFields.length > 0;
      }

      updateQuantityInput() {
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(this.selectedVariantId));
        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
        this.syncQuantityWithMainForm();
      }

      setObserveTarget() {
        const target = this.productFormActions;
        if (target) {
          this.observer.observe(target);
          this.observeTarget = target;
        }
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('#product-form-sticky-atc-bar');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncWithMainProductForm() {
        this.variantChangeUnsubscribe = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          if (!this.mainProductInfo) return;
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }

          this.updateQuantityInput();
          this.updateProductImage(variant);
        });
      }

      updateProductImage(variant) {
        const imageContainer = this.querySelector('.sticky-atc-bar__product-image');
        if (!imageContainer) return;

        const img = imageContainer.querySelector('img');
        if (!img) return;

        /* Get full variant data from variantData array */
        const fullVariant = this.variantData.find((v) => v.id === variant.id);
        if (!fullVariant) return;

        /* Check if variant has featured_media */
        const featuredMediaId = fullVariant.featured_media?.id || variant.featured_media?.id;
        if (!featuredMediaId) {
          /* Variant has no featured image, keep current image */
          return;
        }

        /* Find the corresponding media item in the main product gallery */
        const mediaGallery = this.mainProductInfo.querySelector('[id^="MediaGallery-"]');
        if (!mediaGallery) {
          /* Fallback: try to get image from fetched HTML in variantChange event */
          this.updateProductImageFromHTML(variant, img);
          return;
        }

        const mediaItem = mediaGallery.querySelector(
          `.product__media-item[data-media-id="${featuredMediaId}"]`
        );
        if (!mediaItem) {
          /* Fallback: try to get image from fetched HTML */
          this.updateProductImageFromHTML(variant, img);
          return;
        }

        /* Get the image element from the media item */
        const mediaImage = mediaItem.querySelector('img');
        if (!mediaImage) {
          this.updateProductImageFromHTML(variant, img);
          return;
        }

        /* Get image attributes */
        const newSrc = mediaImage.src || mediaImage.dataset.src;
        const newSrcset = mediaImage.srcset || mediaImage.dataset.srcset;
        const newSizes = mediaImage.sizes;
        const newAlt = mediaImage.alt || variant.title;

        if (!newSrc) {
          this.updateProductImageFromHTML(variant, img);
          return;
        }

        /* Update the sticky ATC image */
        this.setImageAttributes(img, newSrc, newSrcset, newSizes, newAlt);
      }

      updateProductImageFromHTML(variant, img) {
        /* Fallback: fetch updated section HTML to get variant image */
        fetch(`${this.getAttribute('data-url')}?variant=${variant.id}&section_id=${this.sectionId}`)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
          })
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const stickyAtcSection = parsedHTML.querySelector(`#shopify-section-${this.sectionId}`);
            if (!stickyAtcSection) return;

            const newImageContainer = stickyAtcSection.querySelector('.sticky-atc-bar__product-image');
            if (!newImageContainer) return;

            const newImg = newImageContainer.querySelector('img');
            if (!newImg) return;

            const newSrc = newImg.src || newImg.dataset.src;
            const newSrcset = newImg.srcset || newImg.dataset.srcset;
            const newSizes = newImg.sizes;
            const newAlt = newImg.alt || variant.title;

            if (newSrc) {
              this.setImageAttributes(img, newSrc, newSrcset, newSizes, newAlt);
            }
          })
          .catch((error) => {
            console.error('Error updating sticky ATC image:', error);
          });
      }

      setImageAttributes(img, src, srcset, sizes, alt) {
        img.src = src;
        if (srcset) {
          img.srcset = srcset;
        } else {
          img.removeAttribute('srcset');
        }
        if (sizes) {
          img.sizes = sizes;
        }
        img.alt = alt || '';

        /* Trigger load event for lazy loading if using image-lazy */
        if (img.is === 'image-lazy' && typeof img.load === 'function') {
          img.load();
        }
      }

      syncQuantityWithMainForm() {
        if (!this.quantityInput || !this.mainProductInfo) return;

        /* Get main form quantity input */
        const getMainQuantityInput = () => {
          /* Try to find quantity input within main product form */
          const mainForm = this.mainProductInfo.querySelector('form[is="product-form"]');
          if (mainForm) {
            return mainForm.querySelector('quantity-input input');
          }
          /* Fallback: search within product-info */
          return this.mainProductInfo.querySelector('quantity-input input');
        };

        /* Update main form quantity from sticky ATC */
        const syncToMainForm = () => {
          if (this.isSyncingQuantity) return;
          const mainQuantityInput = getMainQuantityInput();
          if (!mainQuantityInput) return;

          const stickyValue = parseInt(this.quantityInput.value) || 0;
          const mainValue = parseInt(mainQuantityInput.value) || 0;

          if (stickyValue !== mainValue) {
            this.isSyncingQuantity = true;
            mainQuantityInput.value = stickyValue;
            mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            setTimeout(() => {
              this.isSyncingQuantity = false;
            }, 0);
          }
        };

        /* Update sticky ATC quantity from main form */
        const syncFromMainForm = () => {
          if (this.isSyncingQuantity) return;
          const mainQuantityInput = getMainQuantityInput();
          if (!mainQuantityInput) return;

          const stickyValue = parseInt(this.quantityInput.value) || 0;
          const mainValue = parseInt(mainQuantityInput.value) || 0;

          if (stickyValue !== mainValue) {
            this.isSyncingQuantity = true;
            this.quantityInput.value = mainValue;
            this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            setTimeout(() => {
              this.isSyncingQuantity = false;
            }, 0);
          }
        };

        /* Delegate sticky ATC quantity changes (survives updateQuantityInput() replacing the block) */
        this.boundStickyQuantityDelegate = (e) => {
          if (!this.contains(e.target) || !e.target.closest('quantity-input')) return;
          syncToMainForm();
        };
        this.addEventListener('change', this.boundStickyQuantityDelegate);
        this.addEventListener('input', this.boundStickyQuantityDelegate);

        /* Listen to main form quantity changes */
        const setupMainFormListener = () => {
          const mainQuantityInput = getMainQuantityInput();
          if (mainQuantityInput) {
            mainQuantityInput.addEventListener('change', syncFromMainForm);
            mainQuantityInput.addEventListener('input', syncFromMainForm);
            return mainQuantityInput;
          }
          return null;
        };

        let mainQuantityInput = setupMainFormListener();

        /* Also listen for when main form quantity input is added/updated dynamically */
        this.quantityObserver = new MutationObserver(() => {
          const newMainQuantityInput = getMainQuantityInput();
          if (newMainQuantityInput && newMainQuantityInput !== mainQuantityInput) {
            /* Remove old listeners if element changed */
            if (mainQuantityInput) {
              mainQuantityInput.removeEventListener('change', syncFromMainForm);
              mainQuantityInput.removeEventListener('input', syncFromMainForm);
            }
            /* Add new listeners */
            newMainQuantityInput.addEventListener('change', syncFromMainForm);
            newMainQuantityInput.addEventListener('input', syncFromMainForm);
            mainQuantityInput = newMainQuantityInput;
          }
        });

        if (this.mainProductInfo) {
          this.quantityObserver.observe(this.mainProductInfo, {
            childList: true,
            subtree: true,
          });
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscribe) {
          this.variantChangeUnsubscribe();
        }
        if (this.select && this.boundSelectHandler) {
          this.select.removeEventListener('change', this.boundSelectHandler);
        }
        if (this.submitButton && this.boundSubmitHandler) {
          this.submitButton.removeEventListener('click', this.boundSubmitHandler);
        }
        if (this.boundStickyQuantityDelegate) {
          this.removeEventListener('change', this.boundStickyQuantityDelegate);
          this.removeEventListener('input', this.boundStickyQuantityDelegate);
        }
        if (this.quantityObserver) {
          this.quantityObserver.disconnect();
        }
      }
    }
  );
}
